export class ExteriorFeatureLayout {
	public fields = [{ fieldName: 'exteriorFeatureType', label: 'Type' }];
}
